import {
  AspectRatio,
  Center,
  HStack,
  Link as ChakraLink,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react'
import numeral from 'numeral'
import type { ReactElement } from 'react'
import { AiOutlineLink } from 'react-icons/ai'
import type { Interceptors } from 'use-http'
import useFetch, { CachePolicies } from 'use-http'
import type { ObjectOfBandwidthUrlAndViews } from '../../interfaces'
import AnalyticsFilePreview from './AnalyticsFilePreview'

const AnalyticsFileElement = ({
  bandwidth,
  url,
  views,
  forceimagePreview
}: ObjectOfBandwidthUrlAndViews): ReactElement => {
  return (
    <VStack
      borderColor="appPaleLilac"
      borderWidth="1px"
      spacing={0}
      cursor="pointer"
      width="13.5%"
      marginRight="0.75%"
      marginBottom="1%"
      overflow="hidden"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
    >
      <AspectRatio width="100%" ratio={1 / 1}>
        <AnalyticsFilePreview url={url} forceimagePreview={forceimagePreview} />
      </AspectRatio>
      <VStack
        spacing={1}
        paddingX={2}
        paddingY={1}
        width="100%"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <HStack spacing={0} width="full" justifyContent="space-between">
          <Text color="appSlate" fontSize="sm">
            {`${numeral(bandwidth).format('0.0ib').replace('i', '')}, ${numeral(
              views,
            )
              .format('0.0a')
              .toUpperCase()} requests`}
          </Text>
          <ChakraLink href={url} isExternal>
            <AiOutlineLink />
          </ChakraLink>
        </HStack>
      </VStack>
    </VStack>
  )
}

export default AnalyticsFileElement
